import { render } from "./CreateQuotaTariff.vue?vue&type=template&id=224fbf88&scoped=true"
import script from "./CreateQuotaTariff.vue?vue&type=script&lang=js"
export * from "./CreateQuotaTariff.vue?vue&type=script&lang=js"

import "./CreateQuotaTariff.vue?vue&type=style&index=0&id=224fbf88&lang=scss&scoped=true"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224fbf88"]])

export default __exports__